import webSwitch from './web-switch'
import webRadio from './web-radio'
const components = [
    webSwitch,
    webRadio
]

const install = function (Vue) {
    if(install.installed) return
    components.map(component => Vue.component(component.name,component))
}

if (typeof window !== 'undefined' && window.Vue){
    install(window.Vue)
}

export default {
    install,
    webSwitch,
    webRadio
}
